// extracted by mini-css-extract-plugin
export default {"layout":"PuE8sQN9","content":"QtJWbaxf","breadcrumbLink":"JFUR40YZ"};